import { render, staticRenderFns } from "./DashSinotico.vue?vue&type=template&id=18d1559a&scoped=true&"
import script from "./DashSinotico.vue?vue&type=script&lang=js&"
export * from "./DashSinotico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d1559a",
  null
  
)

export default component.exports